module.exports = /** @type {Record<string, string>} */ {
  free: "Free",
  pro: "Pro",
  team: "Team",
  enterprise: "Enterprise",
};
